import { z } from "zod";

import TextFormGroup from "../../FormGroups/TextFormGroup.jsx";

const stringOrEmpty = z.preprocess((val) => {
    if (val === "" || val === null || val === undefined) return undefined;
    return val;
}, z.string().optional());

export const UploadNameSettingsSchema = z.object({
    uploadName: stringOrEmpty,
});

export const UploadNameSettingsValues = (settings) => ({
    uploadName: settings?.uploadName ?? "",
});

export default function UploadNameSettingsFormFields({
    control,
    errors,
    setValue,
    defaultAppSettings,
}) {
    return (
        <>
            <h4>Upload name</h4>
            <TextFormGroup
                label="Upload name"
                name="settings.uploadName"
                control={control}
                errors={errors}
                setValue={setValue}
                defaultValue={defaultAppSettings ? "" : undefined}
                placeholder={
                    defaultAppSettings
                        ? defaultAppSettings?.uploadName != null
                            ? `Leave empty to use default: ${defaultAppSettings?.uploadName}`
                            : "Leave empty to ignore"
                        : undefined
                }
            />
        </>
    );
}
